import Chart from "chart.js";
import { FontStyles } from "../../components";
import { fonts } from "../../config";
Chart.defaults.global.defaultFontFamily = "neue roman";

export function createBarScalesX(
  gridColor?: string,
  labelsColor?: string,
  stacked?: boolean,
  max?: number,
  maxTick: number = 7.5,
  type: string | null = "money"
) {
  return {
    defaultFontFamily: fonts.bold,
    yAxes: [
      {
        stacked: false,
        gridLines: {
          drawTicks: false,

          color: gridColor,
        },
        ticks: {
          fontFamily: FontStyles.medium12.fontFamily,
          fontSize: 12,
          fontColor: labelsColor,
          beginAtZero: true,
          maxTicksLimit: maxTick,
          padding: 20,
          max,
          callback: function (value, index, values) {
            if (type === "money") {
              return "R$ " + value.toFixed(2);
            } else if (type === "percent") {
              return value.toFixed(1) + "%";
            } else {
              return value;
            }
          },
        },
      },
    ],
    xAxes: [
      {
        stacked: false,
        gridLines: {
          drawTicks: false,

          color: "transparent",
        },
        ticks: {
          fontFamily: FontStyles.medium12.fontFamily,
          fontSize: 12,
          fontColor: labelsColor,
          beginAtZero: false,
          padding: 20,
          maxTicksLimit: 100000,
        },
      },
    ],
  };
}
export function createBarScales(
  gridColor?: string,
  labelsColor?: string,
  stacked?: boolean,
  max?: number,
  maxTick: number = 7.5,
  type: string | null = "money"
) {
  return {
    defaultFontFamily: fonts.bold,
    yAxes: [
      {
        stacked: false,

        ticks: {
          fontFamily: FontStyles.medium12.fontFamily,
          fontSize: window.innerWidth < 586 ? 6 : 14,
          fontColor: labelsColor,
          beginAtZero: true,
          maxTicksLimit: maxTick,
          padding: 0,
          max,
          callback: function (value, index, values) {
            if (type === "money") {
              return "R$ " + value.toFixed(2);
            } else if (type === "percent") {
              return value + "%";
            } else {
              return value;
            }
          },
        },
      },
    ],
    xAxes: [
      {
        stacked: false,
        gridLines: {
          drawTicks: false,

          color: gridColor,
        },

        ticks: {
          fontFamily: FontStyles.medium12.fontFamily,
          fontSize: window.innerWidth < 586 ? 6 : 14,
          fontColor: labelsColor,
          beginAtZero: false,
          padding: 16,
          maxTicksLimit: 100000,
        },
      },
    ],
  };
}

export function createBarScalesY(
  gridColor?: string,
  labelsColor?: string,
  stacked?: boolean,
  max?: number,
  maxTick: number = 7.5,
  type: string | null = "money"
) {
  return {
    defaultFontFamily: fonts.bold,
    yAxes: [
      {
        stacked: false,
        gridLines: {
          drawTicks: false,

          color: "transparent",
        },
        ticks: {
          fontFamily: FontStyles.medium12.fontFamily,
          fontSize: window.innerWidth < 586 ? 6 : 12,
          fontColor: labelsColor,
          beginAtZero: false,
          padding: 20,
          maxTicksLimit: 100000,
        },
      },
    ],
    xAxes: [
      {
        stacked: false,
        gridLines: {
          drawTicks: false,

          color: gridColor,
        },
        ticks: {
          fontFamily: FontStyles.medium12.fontFamily,
          fontSize: window.innerWidth < 586 ? 7 : 16,
          fontColor: labelsColor,
          beginAtZero: true,
          maxTicksLimit: maxTick,
          padding: 20,
          max,
          callback: function (value, index, values) {
            if (type === "money") {
              return "R$ " + value.toFixed(2);
            } else if (type === "percent") {
              return value.toFixed(1) + "%";
            } else {
              return value;
            }
          },
        },
      },
    ],
  };
}

export function createLayoutWithDatalabels() {
  return {
    mode: "dataset",
    padding: {
      top: 40,
      right: 0,
      bottom: 0,
      left: 0,
    },
  };
}
